// Contracts for «Mahjong Hand» (mahjong, 麻将胡牌): a single-player draw game on the user's seed pair —
// 14 tiles, up to two exchanges, the final hand is paid by the combination table.
//   GET  /api/mahjong/state                          → MjStateResponse
//   POST /api/mahjong/start    body MjStartInput     → MjActionResponse
//   POST /api/mahjong/exchange body MjExchangeInput  → MjActionResponse
//   POST /api/mahjong/stand    body MjStandInput     → MjActionResponse
import { z } from 'zod';
import { zAmount, zIdempotencyKey } from '../common';
import type { FairProof } from '../fair';

export const MJ_HAND = 14;
export const MJ_EXCHANGES = 3;
export const MJ_CATEGORIES = ['thirteenOrphans', 'allHonors', 'fullFlush', 'allPungs', 'halfFlush', 'sevenPairs', 'chickenHand', 'ready', 'none'] as const;
export type MjCategory = (typeof MJ_CATEGORIES)[number];

export const zMjStartInput = z.object({ bet: zAmount, idempotencyKey: zIdempotencyKey }).strict();
export const zMjExchangeInput = z.object({ gameId: z.string().min(1).max(64), round: z.number().int().min(1).max(MJ_EXCHANGES), discard: z.array(z.number().int().min(0).max(135)).max(MJ_HAND) }).strict();
export const zMjStandInput = z.object({ gameId: z.string().min(1).max(64) }).strict();
export type MjStartInput = z.infer<typeof zMjStartInput>;
export type MjExchangeInput = z.infer<typeof zMjExchangeInput>;
export type MjStandInput = z.infer<typeof zMjStandInput>;

export type MjStatus = 'active' | 'done';
export interface MjGameView {
  gameId: string; betId: string; bet: number;
  hand: number[];            // физические id плиток (kind = id >> 2), текущая рука, 14 шт.
  exchangesUsed: number;     // 0…3
  discards: number[][];      // сбросы по заменам
  status: MjStatus;
  category: MjCategory | null;   // итог (null пока active)
  multiplier: number; payout: number;
  nextTiles: number[] | null;    // после конца партии — следующие 5 плиток стены
}
export interface MjPayRow { category: MjCategory; multiplier: number }
export interface MjStateResponse {
  game: MjGameView | null;
  fair: { serverSeedHash: string; clientSeed: string; nonce: number };
  paytable: MjPayRow[]; minBet: number; maxBet: number; maxWin: number;
}
export interface MjActionResponse { game: MjGameView; balance: number; fair: FairProof; duplicate: boolean }
export interface MjBetContext { hand0: number[]; discards: number[][]; final: number[]; deck: number[] | null }
